import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const MobileTopbarSubNavWrapper = styled('div')`
  color: white;
  text-align: center;
  width: 100%;
  position: relative;
  background: ${({ theme }) => theme.color.noir};
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  height: ${({ theme }) => theme.x7spacePx}px;
  ${media.lgUp`
	    display: none;
    `};
`;

interface NavigationProps {
  hasAction: boolean;
}

export const Navigation = styled('nav')<NavigationProps>`
  position: absolute;
  bottom: 0;
  ${({ hasAction }) => {
    if (hasAction) {
      return css`
        right: ${({ theme }) => theme.x14space * 10}px;
        left: 0px;
      `;
    } else {
      return css`
        width: 100%;
      `;
    }
  }};
`;

export const ActionWrapper = styled('div')`
  top: 0;
  bottom: 1px;
  right: ${({ theme }) => theme.x2spacePx}px;
  text-align: right;
  padding-top: 10px;
  position: absolute;
  background: ${({ theme }) => theme.color.noir};
`;

export const List = styled('ul')`
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  text-align: left;
`;

interface ListItemProps {
  selected: boolean;
}

export const ListItem = styled('li')<ListItemProps>`
  font-size: ${({ theme }) => theme.x2space - 0.2}rem;
  display: inline-block;
  height: 54px;
  > a {
    padding: ${({ theme }) => theme.x2spacePx}px;
    display: inline-block;
  }
  ${({ selected }) =>
    selected &&
    css`
      box-shadow: inset 0 -4px 0 0px ${({ theme }) => theme.color.brand01};
      &:disabled {
        opacity: 1;
      }
    `};
`;
